import { Tabs, TabsList, TabsTrigger } from "src/components/ui/tabs";
import { Link } from "@tanstack/react-router";
import {
  allReferences,
  sortCategories,
} from "src/components/homepage/references/sortCategories";
import { FC, useMemo } from "react";
import { components } from "src/strapi/schema";

export const ReferenceFilter: FC<{
  defaultTabSlug: string;
  rawCategories: components["schemas"]["Category"][];
}> = ({ defaultTabSlug, rawCategories }) => {
  const categories = useMemo(
    () => sortCategories(rawCategories ?? []),
    [rawCategories],
  );

  if (!categories) {
    return null;
  }

  return (
    <div className={"container mx-auto"}>
      <Tabs defaultValue={defaultTabSlug} className={"w-full overflow-x-auto"}>
        <TabsList className={"mb-2"}>
          {categories?.map((category) => (
            <Link
              key={category.slug}
              to={
                category.slug === allReferences.slug
                  ? "/reference"
                  : `/reference/kategorie/$categorySlug`
              }
              params={{ categorySlug: category.slug }}
            >
              {category.slug && (
                <TabsTrigger value={category.slug}>{category.name}</TabsTrigger>
              )}
            </Link>
          ))}
        </TabsList>
      </Tabs>
    </div>
  );
};
